import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { chartHatchBackground, chartToneBgClass, chartToneBorderClass, chartToneTextClass, chartToneVar } from './chart-tone';
const SIZE = {
    sm: 'size-[var(--component-chart-swatch)]',
    md: 'size-[var(--component-chart-marker)]'
};
function shapeClass(shape, tone, s) {
    switch(shape){
        case 'square':
            return cn('inline-block shrink-0 rounded-[var(--radius-xs)]', s, chartToneBgClass[tone]);
        case 'dot':
            return cn('inline-block shrink-0 rounded-full', s, chartToneBgClass[tone]);
        case 'ring':
            return cn('inline-block shrink-0 rounded-full border-2 bg-[var(--surface-card)]', s, chartToneBorderClass[tone]);
        case 'dashed-ring':
            return cn('inline-block shrink-0 rounded-full border-2 border-dashed bg-[var(--surface-card)]', s, chartToneBorderClass[tone]);
        case 'triangle':
            return cn('inline-flex shrink-0', s, chartToneTextClass[tone]);
        case 'diamond':
            return cn('inline-block shrink-0 rotate-45 scale-75 rounded-[var(--radius-xs)]', s, chartToneBgClass[tone]);
        case 'line':
            return cn('inline-block h-0.5 w-3 shrink-0 rounded-full', chartToneBgClass[tone]);
        case 'dashed-line':
            return cn('inline-block h-0 w-3 shrink-0 border-t-2 border-dashed', chartToneBorderClass[tone]);
        case 'outline':
            return cn('inline-block shrink-0 rounded-[var(--radius-xs)] border-2', s, chartToneBorderClass[tone]);
        case 'hatch':
            return cn('inline-block shrink-0 rounded-[var(--radius-xs)] border border-[color:var(--border-dashed)]', s);
        case 'bar':
            return cn('inline-block h-3 w-0.5 shrink-0', chartToneBgClass[tone]);
        case 'band':
            return cn('inline-block shrink-0 border-x border-dashed', s, chartToneBorderClass[tone]);
    }
}
/** A chart glyph: legend swatch, identity chip or plot marker in a chart tone. */ export const SpecraSwatch = /*#__PURE__*/ React.forwardRef(({ className, label, shape = 'square', size = 'sm', style, tone, ...props }, ref)=>{
    const shapeStyle = shape === 'hatch' ? {
        backgroundImage: chartHatchBackground
    } : shape === 'band' ? {
        background: `color-mix(in srgb, ${chartToneVar[tone]} 14%, transparent)`
    } : undefined;
    const a11y = label ? {
        role: 'img',
        'aria-label': label
    } : {
        'aria-hidden': true
    };
    return /*#__PURE__*/ _jsx("span", {
        ...a11y,
        className: cn(shapeClass(shape, tone, SIZE[size]), className),
        "data-shape": shape,
        "data-tone": tone,
        ref: ref,
        style: shapeStyle || style ? {
            ...shapeStyle,
            ...style
        } : undefined,
        ...props,
        children: shape === 'triangle' ? /*#__PURE__*/ _jsx("svg", {
            "aria-hidden": "true",
            className: "size-full",
            viewBox: "0 0 10 10",
            children: /*#__PURE__*/ _jsx("polygon", {
                fill: "currentColor",
                points: "5,0.5 9.5,9.5 0.5,9.5"
            })
        }) : null
    });
});
SpecraSwatch.displayName = 'SpecraSwatch';
